<app-breadcrumb></app-breadcrumb>
<div class="container">
    <div class="container-flight-detail">
        <div class=details-col>
            <div class="map-container">
                <div id="map" [class.dark-theme]="theme$ === 'dark'">
                    <button class="map-reset-btn" (click)="onResetMap()">
                        <i class="pi pi-refresh"></i>
                    </button>
                </div>
            </div>
            @if(sequence && sequence.dutyPeriodSummaries) {
            <div class="col">
                <div class="header">
                    <div class="tag-sequence">{{sequence.sequenceNumber}}</div>
                    @if (sequence.addReasonCode && validateReasonCode(sequence.addReasonCode)) {
                    <div class=tag-container>
                        <div class="reason-code" (click)="op.toggle($event)">{{validateReasonCode(sequence.addReasonCode)}}</div>
                    </div>
                    }
                </div>
                <app-data-box class="data-box" headerTitle="Sequence Totals" [dataBoxItems]="sequenceTotalsDatabox"
                    [helpComponent]="sequenceTotalsInfoDialog">
                </app-data-box>

            </div>
            <div class="flight-list">
                <!-- <div class="header-title"></div> -->
                <div *ngFor="let duty of sequence?.dutyPeriodSummaries">
                    <div *ngFor="let leg of duty.legs; let i=index">
                        <app-flight-item (click)="onLegClicked(leg, sequence!, 'sequence-detail')"
                            [flightNumber]="leg.flightNumber" [aircraft]="leg.aircraft"
                            [depStation]="leg.departureStation.code" [arrStation]="leg.arrivalStation.code"
                            [depTimes]="leg.departure" [arrTimes]="leg.arrival"
                            [flightTimeActual]="leg.flightTimeActual" [isDeadhead]="leg.isDeadhead"
                            [isCancelled]="leg.isCancelled">
                        </app-flight-item>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>
<p-overlayPanel #op>
    <div class="col">
        <div class="title-overlay">
            Add Reason Code
        </div>              
        <div class="row">
            <div class="code">
                {{validateReasonCode(sequence?.addReasonCode || '')}}:
            </div>
            <div class="reason-code-description">
                {{reasonCodes[validateReasonCode(sequence?.addReasonCode || '') || '']}}
            </div>
        </div>
    </div>
</p-overlayPanel>